import * as React from 'react';
export var formDataContext = React.createContext(null);
